<template>
  <div class="accountInfo">
    <head-panel title="账号管理" subtitle="ACCOUNT MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit">{{currentTitle}}</h3>
      <el-form :model="form" ref="form" class="ruleForm" :rules="rules" label-width="12%">
        <h4 class="form-title">账户信息</h4>
        <el-form-item label="账户名称" prop="name">
          <el-input class="input_sm" placeholder="请输入账户名称" v-model="form.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="公司名称(广告主名称)" prop="company" disabled>
          <el-input class="input_lg" placeholder="请输入公司名称(广告主名称)" v-model="form.company" disabled></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input class="input_sm" placeholder="请输入邮箱" v-model="form.email" disabled></el-input>
        </el-form-item>
        <el-form-item label="网站URL" prop="url">
          <el-tooltip effect="dark" :content="form.url" placement="bottom-start">
            <el-input v-model="form.url" class="input_lg" placeholder="请输入网站URL" disabled></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="行业类型" prop="industryType" v-if="!isAgency">
          <ny-select
            :data="accountinfo.industryMenu"
            v-model="form.industryType"
            :keyValue="['id', 'name']"
            @change="changeIndustry"
            type="industryType"
            placeholder="请选择"
            class="advertiseSelect input_sm mr20"
            disabled
          ></ny-select>
          <ny-select
            :data="accountinfo.industrySecondMenu"
            v-model="form.industrySecondType"
            :keyValue="['id', 'name']"
            type="industryType"
            placeholder="请选择"
            disabled
            class="advertiseSelect input_sm"
          ></ny-select>
        </el-form-item>
        <Industry
          :industryData.sync="industryData"
          :post="post"
          ref="industry"
          :deleteArray="deleteArray"
          :disabled="industryDisabled"
        ></Industry>
        <el-form-item label="注册地址">
          <city-select
            class="address-select"
            :arrCity="accountInfo.cityArr"
            @changeSelect="changeSelectCity"
            part="registerCity"
            :defaultCity="form.registerCity"
            :disabled="isSuccess"
          ></city-select>
          <el-input
            class="input_lg ml16"
            placeholder="请输入地址"
            v-model="form.address"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <h4 class="form-title">财务信息</h4>
        <el-form-item label="对公银行名称" prop="publicBank">
          <ny-select
            :data="accountInfo.publicBankMenu"
            v-model="form.publicBank"
            :keyValue="['value', 'name']"
            @changeSelectMenu="changeSelect"
            type="publicBank"
            placeholder="请选择"
            class="advertiseSelect input_sm"
            :disabled="isSuccess"
          ></ny-select>
        </el-form-item>
        <el-form-item label="对公开户支行" prop="bankAddress">
          <city-select
            class="address-select"
            part="bankCity"
            :arrCity="accountInfo.cityArr"
            @changeSelect="changeSelectCity"
            :defaultCity="form.bankCity"
            :disabled="isSuccess"
          ></city-select>
          <!--<select-menu :list="menuList" :current="form.subBranch" :keyValue="['value', 'name']"
                       @changeSelectMenu="changeSelect" part="adr"
                       placeholder="请选择"
                       class="advertiseSelect input_sm mr20">
          </select-menu>-->
          <el-input
            class="input_lg ml16"
            placeholder="请输入对公开户支行"
            v-model="form.bankAddress"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <el-form-item label="对公银行账号" prop="bankNum">
          <el-input
            class="input_lg"
            placeholder="请输入对公银行账号"
            v-model="form.bankNum"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <h4 class="form-title">联系人信息</h4>
        <el-form-item label="联系人姓名" prop="contacter">
          <el-input
            class="input_sm"
            placeholder="请输入联系人姓名"
            v-model="form.contacter"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="phone">
          <el-input
            class="input_sm"
            placeholder="请输入手机号"
            v-model="form.phone"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人地址" prop="linkAddress">
          <city-select
            class="address-select"
            part="linkCity"
            :arrCity="accountInfo.cityArr"
            @changeSelect="changeSelectCity"
            :defaultCity="form.linkCity"
            :disabled="isSuccess"
          ></city-select>
          <el-input
            class="input_lg ml16"
            placeholder="请输入地址"
            v-model="form.linkAddress"
            :disabled="isSuccess"
          ></el-input>
        </el-form-item>
        <el-form-item class="btnGroups">
          <el-button
            size="large"
            type="primary"
            @click="submitForm('form')"
            v-if="!isSuccess"
            :disabled="committing"
          >{{committing ? '提交中···' : '提交'}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="auditStatus"
      v-if="titleShow"
    >{{auditStatus === 1 ? status1 : (auditStatus === 0 ? status0 : (status2 + '('+ auditReason +')'))}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { headPanel, NySelect, citySelect } from '@/global/components';
import Industry from '@/global/views/subAccount/industry.vue'
import IndustryMixns from '@/global/views/subAccount/industry.js'
import { post, get, patch, remove } from '@/manager/http';
export default {
  mixins: [IndustryMixns],
  data () {
    var industryType = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择行业类型'));
      } else {
        callback();
      }
    };
    var publicBank = (rule, value, callback) => {
      if (value === '') {
        // callback(new Error('请选择对公银行'));
        callback()
      } else {
        callback();
      }
    };
    var subBranch = (rule, value, callback) => {
      if (value === '') {
        // callback(new Error('请输入对公开户支行'));
        callback()
      } else if (value.toString().length > 50) {
        callback(new Error('输入内容不得超过50个字符'))
      } else {
        callback();
      }
    };
    var bankNum = (rule, value, callback) => {
      let reg = /^[0-9\s]*$/
      if (!value) {
        // callback(new Error('请输入银行账号'));
        callback()
      } else if (!reg.test(value)) {
        callback(new Error('请输入数字'))
      } else if (value.toString().length > 50) {
        callback(new Error('输入内容不得超过50个字符'))
      } else {
        callback()
      }
    };
    return {
      post: post,
      get: get,
      patch: patch,
      remove: remove,
      currentTitle: '账户信息',
      status0: '您尚未通过身份验证，无法正常使用，请在账户管理中完善信息', // 待审核或者未提交
      status1: '账号信息审核成功', // 通过
      status2: '账号信息审核未通过：请重新提交资质', // 未通过
      auditReason: '', // 拒绝原因
      committing: false, // 提交按钮的提交状态
      auditStatus: 0,
      isSuccess: false,
      uploadPost: 'test',
      isNew: false,
      titleShow: false,
      isAgency: false,
      form: {
        name: '',
        pass: '',
        checkPass: '',
        email: '',
        company: '',
        industryType: '',
        url: '',
        address: '',
        registerCity: {},
        contacter: '',
        phone: '',
        linkAddress: '',
        linkCity: {},
        publicBank: '',
        bankCity: {},
        subBranch: '',
        bankAddress: '',
        bankNum: ''
      },
      rules: {
        name: [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
        url: [
          { required: false, message: '请输入网站url', trigger: 'blur' },
          { required: false, type: 'url', message: '请输入正确网站url', trigger: 'blur,change' }
        ],
        company: [{ required: true, message: '请输入公司名称(广告主名称)', trigger: 'blur' }],
        industryType: [{ required: true, validator: industryType, trigger: 'change' }],
        publicBank: [{ validator: publicBank, trigger: 'change' }],
        bankAddress: [{ validator: subBranch, trigger: 'change' }],
        bankNum: [{ validator: bankNum, trigger: 'blur' }],
        contacter: [{ required: false, max: 50, message: '输入内容不得超过50个字符', trigger: 'blur' }],
        phone: [{ required: false, pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }],
        linkAddress: [{ required: false, max: 50, message: '输入内容不得超过50个字符', trigger: 'blur' }]
      }
    };
  },
  computed: {
    ...mapGetters({
      accountInfo: 'account/account',
      userid: 'login/userid',
      user: 'login/user'
    })
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.$store.dispatch('account/getPublicBankMenu')
      await this.$store.dispatch('account/getCityAll')
      await this.getAccountInfo()
    },
    getAccountInfo () {
      get('/agency/account/' + this.userid).then(res => {
        if (res.code === 1) {
          let data = res.data
          if (!data && typeof (data) !== 'undefined' && data !== 0) {
            this.isNew = true
            this.auditStatus = 0
            this.titleShow = true
            return false
          }
          this.form.registerCity = {
            prov: data.reg_pro + '',
            city: data.reg_city + '',
            district: data.reg_area + ''
          }
          this.auditStatus = parseInt(data.audit_status)
          // this.isSuccess = this.industryDisabled = this.auditStatus !== 2
          this.auditReason = data.audit_reason.msg ? data.audit_reason.msg : ''
          this.titleShow = true
          if (this.auditStatus === 1) {
            if (!data.first_pass) {
              this.titleShow = false
            }
            setTimeout(() => {
              this.titleShow = false
            }, 10000)
          }
          this.form.address = data.reg_address
          // 财务信息
          this.form.publicBank = data.bank
          this.form.bankCity = {
            prov: data.bank_pro + '',
            city: data.bank_city + '',
            district: data.bank_area + ''
          }
          this.form.bankAddress = data.bank_addr
          this.form.bankNum = data.account
          // 联系人
          this.form.contacter = data.username
          this.form.phone = data.tel
          this.form.linkCity = {
            prov: data.pro + '',
            city: data.city + '',
            district: data.area + ''
          }
          this.form.linkAddress = data.address
        }
      })
      get('/agency/user/' + this.userid).then(async res => {
        if (res.code === 1) {
          let data = res.data
          let AgencyIdTag = ['4', '11', '12', '13']
          this.isAgency = AgencyIdTag.indexOf(data.id_tag.toString()) > -1
          this.getIndustryDetails(this.isAgency, this.user.id)
          this.form.name = data.username
          this.form.company = data.corporate_name
          this.form.email = data.email
          this.form.industryType = data.parent_industry + ''
          await this.getIndustryMenu({ type: this.form.industryType })
          this.form.industrySecondType = data.industry + ''
          this.form.url = data.web_url
        }
      })
    },
    changeSelect (value) {
    },
    changeSelectCity ({ prov, city, district, part }) {
      this.form[part] = { prov, city, district, part }
    },
    getParams () {
      let params = {}
      params.user_id = this.userid
      params.corporate_name = this.form.company // 通用信息
      params.industry = this.isAgency ? '' : this.form.industrySecondType
      params.web_url = this.form.url
      params.reg_pro = this.form.registerCity.prov
      params.reg_city = this.form.registerCity.city
      params.reg_area = this.form.registerCity.district
      params.reg_address = this.form.address
      params.username = this.form.contacter // 联系人信息
      params.tel = this.form.phone
      params.pro = this.form.linkCity.prov
      params.city = this.form.linkCity.city
      params.area = this.form.linkCity.district
      params.address = this.form.linkAddress
      params.bank = this.form.publicBank
      params.bank_pro = this.form.bankCity.prov
      params.bank_city = this.form.bankCity.city
      params.bank_area = this.form.bankCity.district
      params.bank_addr = this.form.bankAddress
      params.account = this.form.bankNum
      return params
    },
    submitForm (numberValidateForm) {
      let self = this
      this.$refs[numberValidateForm].validate((valid) => {
        this.$refs.industry.$refs.industryForm.validate((validIn) => {
          let params = self.getParams()
          let uid = self.isNew ? '' : self.userid
          if (valid && validIn) {
            this.committing = true;
            let promiseArr = [
              post('/agency/account/' + uid, params),
              this.submitIndustry({ userid: this.user.id, form: numberValidateForm })
            ]
            if (this.deleteArray.length > 0) {
              promiseArr.push(this.submitDelete())
            }
            Promise.all(promiseArr).then(data => {
              let suc = data.every(res => {
                if (res.code !== 1) {
                  this.committing = false;
                  this.$message.error(res.msg)
                }
                return res.code === 1
              })
              if (suc) {
                this.committing = false;
                self.getAccountInfo()
                self.$message('更改成功')
              }
            }).catch(() => {
              this.committing = false
            })
          }
        })
      });
    }
  },
  components: {
    headPanel,
    NySelect,
    citySelect,
    Industry
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.accountInfo {
  .ruleForm {
    .input_sm {
      width: 210px;
    }
    .input_lg {
      width: 350px;
    }
    .ml16 {
      margin-left: 16px;
    }
    .mr20 {
      margin-right: 20px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .upload_select {
      position: absolute;
      left: 16px;
    }
    .upload-demo {
      width: 310px;
      .el-upload__tip {
        position: absolute;
        top: -7px;
        left: 90px;
      }
    }
    .col-upload {
      margin-left: 16px;
      .el-upload__tip {
        position: absolute;
        top: 23px;
        left: 90px;
      }
      .el-upload-list {
        margin-left: 0;
      }
    }
    .form-title {
      margin-left: 20px;
      font-size: 16px;
      margin-bottom: 10px;
      font-weight: bold;
    }
    .btnGroups {
      text-align: left;
      margin-left: 16px;
    }
    .address-select {
      display: inline-block;
      margin-bottom: 20px;
    }
  }
  .auditStatus {
    width: 100%;
    line-height: 30px;
    background: #fdff92;
    position: absolute;
    top: 45px;
    box-sizing: border-box;
    padding-left: 50px;
    left: 200px;
    transition: all 0.3s;
  }
  .imgShow {
    text-align: center;
    img {
      max-width: 100%;
      height: auto;
    }
    .el-dialog--small {
      width: 50%;
    }
  }
}
.is-collapse {
  .accountInfo {
    .auditStatus {
      left: 64px;
    }
  }
}
</style>
